import apiCaller from "./api-caller";

class ApiReadonly {
  /* READ List */
  list(params) {
    const queryParams = new URLSearchParams();
    queryParams.set("page", params?.page || 1);

    for (const item of [
      "pageSize",
      "sortBy",
      "order",
      "startDate",
      "endDate",
      "filters",
      "personal"
    ]) {
      if (params && params[item]) {
        queryParams.set(item, params[item]);
      }
    }

    const queryString = queryParams.toString();
    const url = `/${this.resource}?${queryString}`;

    return apiCaller.get(url).then((response) => {
      return response.data;
    });
  }

  /* READ Single Record */
  get(id) {
    if (id === "new") {
      return Promise.resolve({ record: { _new: true } });
    }
    return apiCaller.get(`/${this.resource}/${id}`).then((response) => {
      return response.data;
    });
  }
}

export default ApiReadonly;
